module.exports = __webpack_public_path__ + "img/aggressive.2d4049d3.png";